{
    "name": "emaan-reviver-ui",
    "version": "2.0.0",
    "description": "Emaan Reviver - Enterprise-grade React application with Material UI",
    "source": "/src/index.html",
    "scripts": {
        "dev": "parcel --open -p 4000",
        "build:dev": "REACT_APP_ENV=dev parcel build",
        "build:stage": "REACT_APP_ENV=stage parcel build",
        "build:prod": "REACT_APP_ENV=prod parcel build",
        "format": "eslint . --fix",
        "lint": "eslint .",
        "lint:updated": "pipe-git-updated --ext=js -- eslint",
        "prepare": "husky install",
        "prepare-release": "standard-version && prettier --write CHANGELOG.md",
        "prettier": "prettier --check .",
        "prettier-check": "prettier -c --ignore-path .gitignore \"**/*.{css,scss,html,js,json,md,yaml,yml,gql,graphql}\"",
        "prettier-check:updated": "pipe-git-updated --ext=css --ext=scss --ext=html --ext=js --ext=json --ext=md --ext=yaml --ext=yml --ext=gql --ext=graphql -- prettier -c",
        "prettify": "prettier --write --ignore-path .gitignore \"**/*.{css,scss,html,js,json,md,yaml,yml,gql,graphql}\"",
        "prettify:updated": "pipe-git-updated --ext=css --ext=scss --ext=html --ext=js --ext=json --ext=md --ext=yaml --ext=yml --ext=gql --ext=graphql -- prettier --write",
        "test": "jest",
        "test:watch": "jest --watch",
        "test:coverage": "jest --coverage"
    },
    "repository": {
        "type": "git",
        "url": ""
    },
    "keywords": [
        "react",
        "material-ui",
        "admin-panel",
        "enterprise"
    ],
    "author": "",
    "license": "ISC",
    "standard-version": {
        "skip": {
            "commit": true,
            "tag": true
        },
        "types": [
            {
                "type": "feat",
                "section": "Features"
            },
            {
                "type": "fix",
                "section": "Bug Fixes"
            },
            {
                "type": "perf",
                "section": "Performance Improvements"
            },
            {
                "type": "refactor",
                "section": "Maintenance Improvements"
            }
        ]
    },
    "dependencies": {
        "@apollo/client": "^3.11.8",
        "@emotion/react": "^11.13.5",
        "@emotion/styled": "^11.13.5",
        "@mui/icons-material": "^6.3.0",
        "@mui/lab": "^7.0.1-beta.19",
        "@mui/material": "^6.3.0",
        "@mui/x-data-grid": "^7.22.2",
        "@mui/x-date-pickers": "^7.22.2",
        "@react-oauth/google": "^0.12.2",
        "axios": "^1.7.9",
        "date-fns": "^3.6.0",
        "dotenv": "^16.4.7",
        "express": "^4.21.2",
        "graphql": "^16.9.0",
        "notistack": "^3.0.1",
        "prop-types": "^15.8.1",
        "react": "^18.3.1",
        "react-dom": "^18.3.1",
        "react-error-boundary": "^4.1.2",
        "react-redux": "^9.2.0",
        "react-router-dom": "^6.28.0",
        "recharts": "^3.5.1",
        "redux": "^5.0.1",
        "redux-toolkit": "^1.1.2",
        "typesafe-actions": "^5.1.0"
    },
    "devDependencies": {
        "@babel/core": "^7.26.0",
        "@babel/eslint-parser": "^7.25.9",
        "@babel/plugin-proposal-class-properties": "^7.18.6",
        "@babel/plugin-proposal-throw-expressions": "^7.25.9",
        "@babel/plugin-syntax-dynamic-import": "^7.8.3",
        "@babel/plugin-syntax-jsx": "^7.25.9",
        "@babel/plugin-transform-react-jsx": "^7.25.9",
        "@babel/plugin-transform-runtime": "^7.25.9",
        "@babel/polyfill": "^7.12.1",
        "@commitlint/cli": "^19.6.0",
        "@commitlint/config-conventional": "^19.6.0",
        "@parcel/reporter-bundle-analyzer": "^2.13.3",
        "@parcel/transformer-sass": "^2.13.3",
        "@testing-library/jest-dom": "^6.6.3",
        "@testing-library/react": "^16.1.0",
        "@testing-library/user-event": "^14.5.2",
        "babel-jest": "^29.7.0",
        "buffer": "^6.0.3",
        "eslint": "^8.57.1",
        "eslint-config-airbnb": "^19.0.4",
        "eslint-config-prettier": "^9.1.0",
        "eslint-plugin-babel": "^5.3.1",
        "eslint-plugin-import": "^2.31.0",
        "eslint-plugin-jest": "^28.9.0",
        "eslint-plugin-jsx-a11y": "^6.10.2",
        "eslint-plugin-prettier": "^5.2.1",
        "eslint-plugin-react": "^7.37.2",
        "eslint-plugin-react-hooks": "^5.0.0",
        "git-list-updated": "^1.2.1",
        "husky": "^9.1.7",
        "jest": "^29.7.0",
        "jest-environment-jsdom": "^29.7.0",
        "lint-staged": "^15.2.11",
        "os-browserify": "^0.3.0",
        "parcel": "^2.13.3",
        "parcel-reporter-static-files-copy": "^1.5.3",
        "path": "^0.12.7",
        "path-browserify": "^1.0.1",
        "prettier": "^3.4.2",
        "react-test-renderer": "^18.3.1"
    },
    "browserslist": {
        "production": [
            ">0.2%",
            "not dead",
            "not op_mini all"
        ],
        "development": [
            "since 2017-06"
        ]
    },
    "buildDate": 1665339061795,
    "alias": {
        "crypto": false
    }
}
